import React from 'react';
import { AlertBanner, AlertBannerTypes } from '../../Components/AlertBanner';
import styles from './SwitchMedicationInfoBar.module.css';
export function SwitchMedicationInfoBar(props) {
    var prompt = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.regular }, "You selected "),
        React.createElement("span", { className: styles.strongWords },
            props.tradeProductName,
            "."),
        React.createElement("span", { className: styles.regular }, " We\u2019ve selected the "),
        React.createElement("span", { className: styles.strongWords }, "generic name"),
        React.createElement("span", { className: styles.regular }, " of the medication to comply with your prescribing system setting.")));
    return React.createElement(AlertBanner, { promptMessage: prompt, promptType: AlertBannerTypes.Prompt, verticalSpace: true });
}
